import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/college/404.png';
const _withScopeId = n => (_pushScopeId("data-v-37db5666"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "padding-16"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "·", -1));
const _hoisted_8 = {
  class: "flex",
  style: {
    "margin-left": "16px"
  }
};
const _hoisted_9 = {
  style: {
    "margin-left": "4px"
  }
};
const _hoisted_10 = {
  class: "summary font-black"
};
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "标签：", -1));
const _hoisted_14 = {
  class: "summary"
};
const _hoisted_15 = {
  class: "flex align-center justify-between"
};
const _hoisted_16 = {
  key: 1,
  class: "not-found"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "资讯不存在"
}, null, -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "404", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "抱歉，您所查看的资讯已经被作者下架或者删除，换个资讯看看吧！", -1));
import ModuleCard from "@/views/college/components/ModuleCard.vue";
import { useRoute, useRouter } from "vue-router";
import { reactive, ref } from "vue";
import { College } from "@/api/college";
import RecommendAbout from "@/views/college/components/RecommendAbout.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'TopicDetail',
  emits: ['getInfo'],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const params = reactive({
      id: +route.params.id
    });
    const loading = ref(false);
    const info = ref(null);
    const emit = __emit;
    const getDetail = async () => {
      loading.value = true;
      try {
        const res = await College.InfoDetail(params);
        info.value = res.data;
        info.value.content = res.data.content.replace(/\<img/gi, '<img style="max-width:100%;height:auto;"');
        emit('getInfo', res.data);
      } finally {
        loading.value = false;
      }
    };
    getDetail();
    const goBack = () => {
      router.push({
        name: 'zixun'
      });
    };
    const goSpecial = () => {
      router.push({
        name: 'zhuanti',
        params: {
          topicId: info.value?.topicId
        }
      });
    };
    const toDetail = id => {
      router.push({
        name: 'zixunDetail',
        params: {
          id
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_View = _resolveComponent("View");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_space = _resolveComponent("el-space");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_button = _resolveComponent("el-button");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(ModuleCard, null, {
        title: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("span", {
          class: "theme-hover",
          onClick: goBack
        }, "获客学院"), info.value?.topicId ? (_openBlock(), _createElementBlock("span", _hoisted_2, [_createTextVNode("> "), _createElementVNode("span", {
          class: "theme-hover",
          onClick: goSpecial
        }, _toDisplayString(info.value?.topicName), 1)])) : _createCommentVNode("", true)])]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [info.value?.title && (_unref(route).query.status || info.value?.status === 1) ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(info.value?.title), 1), _createVNode(_component_el_space, {
          class: "text-grey",
          style: {
            "margin": "10px 0"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(info.value?.author), 1), info.value?.publishTime ? (_openBlock(), _createElementBlock("div", _hoisted_6, "·")) : _createCommentVNode("", true), _createElementVNode("div", null, _toDisplayString(info.value?.publishTime), 1), _hoisted_7, _createElementVNode("div", null, _toDisplayString(info.value?.origin), 1), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_View)]),
            _: 1
          }), _createElementVNode("span", _hoisted_9, _toDisplayString(info.value?.realViewNum + info.value?.fictitiousViewNum), 1)])]),
          _: 1
        }), _createElementVNode("div", _hoisted_10, _toDisplayString(info.value?.summary), 1), _createElementVNode("div", {
          innerHTML: info.value?.content,
          style: {
            "max-width": "740px",
            "overflow-x": "auto"
          }
        }, null, 8, _hoisted_11), info.value?.tagNameList.length ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_el_space, null, {
          default: _withCtx(() => [_hoisted_13, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value?.tagNameList, tag => {
            return _openBlock(), _createBlock(_component_el_tag, {
              key: tag
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(tag), 1)]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_14, _toDisplayString(info.value?.disclaimer), 1), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", null, [info.value?.nextNewsCmd?.title ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "theme-hover font-black",
          onClick: _cache[0] || (_cache[0] = $event => toDetail(info.value?.nextNewsCmd.id))
        }, "上一篇: " + _toDisplayString(info.value?.nextNewsCmd.title), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", null, [info.value?.previousNewsCmd?.title ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "theme-hover font-black",
          onClick: _cache[1] || (_cache[1] = $event => toDetail(info.value?.previousNewsCmd.id))
        }, "下一篇: " + _toDisplayString(info.value?.previousNewsCmd.title), 1)) : _createCommentVNode("", true)])])])) : !loading.value && info.value?.status !== 1 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_hoisted_17, _hoisted_18, _hoisted_19, _createVNode(_component_el_button, {
          type: "primary",
          onClick: goBack
        }, {
          default: _withCtx(() => [_createTextVNode("返回获客学院")]),
          _: 1
        })])) : _createCommentVNode("", true)])), [[_directive_loading, loading.value]])]),
        _: 1
      }), info.value?.operationRelateRecommendh5Vo?.length ? (_openBlock(), _createBlock(RecommendAbout, {
        key: 0,
        list: info.value?.operationRelateRecommendh5Vo
      }, null, 8, ["list"])) : _createCommentVNode("", true)]);
    };
  }
});